import { render, staticRenderFns } from "./ChatTalkItem.vue?vue&type=template&id=5c8377ec&scoped=true&"
import script from "./ChatTalkItem.vue?vue&type=script&lang=js&"
export * from "./ChatTalkItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8377ec",
  null
  
)

export default component.exports